/** Display labels for built-in mill role slugs (match backend rbac/catalog.py). */
export const ROLE_LABELS = {
  admin: "Administrator",
  manager: "Mill Manager",
  guard: "Gate Security",
  weighbridge: "Weighbridge Operator",
  lab: "Quality Lab",
  supervisor: "Production Supervisor",
  unloading_supervisor: "Unloading Supervisor",
  store_keeper: "Store Keeper",
  production_loading_supervisor: "Production & Loading Supervisor",
  accounts: "Accounts & Finance",
  accounts_manager: "Accounts Manager",
  purchaser: "Purchaser",
  boiler_foreman: "Boiler Foreman",
  boiler_operator: "Boiler Operator",
  parboiled_foreman: "Parboiled Foreman",
  parboiled_operator: "Parboiled Operator",
  milling_foreman: "Milling Foreman",
  milling_operator: "Milling Operator",
};

export const ROLE_HOME_TITLES = {
  guard: "Gate Desk",
  weighbridge: "Weighbridge Desk",
  lab: "Lab Desk",
  accounts: "Accounts Desk",
  accounts_manager: "Accounts Manager Desk",
  supervisor: "Floor Desk",
  unloading_supervisor: "Unloading Desk",
  store_keeper: "Store Keeper Desk",
  production_loading_supervisor: "Packing & Loading Desk",
  purchaser: "Purchasing Desk",
  boiler_foreman: "Boiler Dashboard",
  boiler_operator: "Boiler workspace",
  parboiled_foreman: "Parboiled Dashboard",
  parboiled_operator: "Parboiled workspace",
  milling_foreman: "Milling Dashboard",
  milling_operator: "Milling workspace",
};

export const ROLE_BADGE = {
  admin: { bg: "bg-bansal-gold", text: "text-foreground" },
  manager: { bg: "bg-bansal-sage", text: "text-white" },
  guard: { bg: "bg-slate-600", text: "text-white" },
  weighbridge: { bg: "bg-amber-700", text: "text-white" },
  lab: { bg: "bg-indigo-700", text: "text-white" },
  supervisor: { bg: "bg-teal-700", text: "text-white" },
  unloading_supervisor: { bg: "bg-orange-700", text: "text-white" },
  production_loading_supervisor: { bg: "bg-emerald-800", text: "text-white" },
  accounts: { bg: "bg-rose-700", text: "text-white" },
  accounts_manager: { bg: "bg-rose-900", text: "text-white" },
  purchaser: { bg: "bg-violet-700", text: "text-white" },
  boiler_foreman: { bg: "bg-orange-800", text: "text-white" },
  boiler_operator: { bg: "bg-orange-700", text: "text-white" },
  parboiled_foreman: { bg: "bg-cyan-800", text: "text-white" },
  parboiled_operator: { bg: "bg-cyan-700", text: "text-white" },
  milling_foreman: { bg: "bg-stone-700", text: "text-white" },
  milling_operator: { bg: "bg-stone-600", text: "text-white" },
};

export function roleLabel(slug) {
  return ROLE_LABELS[slug] || slug?.replace(/_/g, " ") || "User";
}

export function isUnloadingSupervisor(user) {
  if (!user) return false;
  const roles = Array.isArray(user.roles) && user.roles.length
    ? user.roles
    : [user.role];
  return roles.includes("unloading_supervisor");
}

/** Roles that can be assigned as unloading floor supervisor on weighbridge routing. */
export function isUnloadingAssignee(user) {
  if (!user) return false;
  const roles = Array.isArray(user.roles) && user.roles.length
    ? user.roles.map((r) => String(r || "").toLowerCase())
    : [String(user.role || "").toLowerCase()];
  if (roles.includes("supervisor") || roles.includes("unloading_supervisor")) return true;
  const name = String(user.role_name || user.name || "").toLowerCase();
  return name.includes("unloading supervisor") || name.includes("paddy unloader");
}
